import { connect } from 'react-redux';
import { getMatrixInvalidRowFormList } from '../../../reducers';
import generateMatrixRowFormName from '../../../utils/generateMatrixRowFormName';

const mapStateToProps = (state, { block: { options, clientUuid } }) => {
  const formList = options.map(option =>
    generateMatrixRowFormName(clientUuid, option.id),
  );
  const invalidRows = getMatrixInvalidRowFormList(state, formList);

  let formErrorMessage = '';
  if (invalidRows.length > 0) {
    formErrorMessage =
      invalidRows.length === options.length
        ? 'Required answers'
        : 'Answer is required for each row';
  }
  return {
    formErrorMessage,
    hasInvalidRowForm: invalidRows.length > 0,
  };
};

export default connect(mapStateToProps);
